/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Inbounds_Reminders_OverInputs */

const en_queue_inbounds_reminders_over = /** @type {(inputs: Queue_Inbounds_Reminders_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbounds the supplier left after the reminders`)
};

/**
* | output |
* | --- |
* | "Inbounds the supplier left after the reminders" |
*
* @param {Queue_Inbounds_Reminders_OverInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_inbounds_reminders_over = /** @type {((inputs?: Queue_Inbounds_Reminders_OverInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Inbounds_Reminders_OverInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_inbounds_reminders_over(inputs)
});